module.exports = __webpack_public_path__ + "img/SOKAL-SRS-Chevy-120921-DealerDraft-Lifestyle.6a78fb88.jpeg";